import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export const SiteLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#faf9f6]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};
